import React, { createContext } from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider, createSelectorHook, createDispatchHook } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import reducer from './NotasFiscais.store';
import watchNotasFiscais from './NotasFiscais.saga';

export const NotasFiscaisContext = createContext();
export const useNotasFiscaisDispatch = createDispatchHook(NotasFiscaisContext);
export const useNotasFiscaisSelector = createSelectorHook(NotasFiscaisContext);

export default function NotasFiscaisProvider({ children }) {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(reducer, applyMiddleware(sagaMiddleware));
  sagaMiddleware.run(watchNotasFiscais);

  return (
    <Provider context={NotasFiscaisContext} store={store}>
      {children}
    </Provider>
  );
}
